import React from 'react';
import { Card, Stack, Chip } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IAudition } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import PublicIcon from '@mui/icons-material/Public';

export interface IAuditionWorkDetails {
    audition: IAudition;
}

const AuditionWorkDetails: React.FC<IAuditionWorkDetails> = ({ audition }) => {
    const { themeStyle } = useThemeContext();

    // Don't render if neither type_of_work nor usage is available
    if (!audition.type_of_work && (!audition.usage || audition.usage.length < 1)) {
        return null;
    }

    return (
        <Stack>
            {/* Type of Work */}
            {audition.type_of_work && (
                <>
                    <TextWithIcon
                        icon={<WorkOutlineIcon sx={{ fontSize: 18, color: theme[themeStyle].tag_white }} />}
                        text="Type of Work"
                    />
                    <Card
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            overflow: 'visible',
                            my: 2,
                            p: 1,
                            height: '100%',
                            backgroundColor: 'rgb(229,244,245)',
                        }}>
                        <Stack height="100%" direction="column" justifyContent="space-between">
                            <Stack
                                sx={{
                                    backgroundColor: 'rgb(229,244,245)',
                                    borderRadius: 1,
                                    padding: '4px 8px',
                                    width: '100%',
                                    my: 1,
                                }}>
                                <Chip
                                    label={audition.type_of_work}
                                    sx={{
                                        backgroundColor: theme[themeStyle].highlight,
                                        color: theme[themeStyle].true_white,
                                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                        fontSize: 12,
                                        height: '28px',
                                        textTransform: 'capitalize',
                                    }}
                                />
                            </Stack>
                        </Stack>
                    </Card>
                </>
            )}

            {/* Usage */}
            {audition.usage && audition.usage.length > 0 && (
                <>
                    <TextWithIcon
                        icon={<PublicIcon sx={{ fontSize: 18, color: theme[themeStyle].tag_white }} />}
                        text="Usage"
                    />
                    <Card
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            overflow: 'visible',
                            my: 2,
                            p: 1,
                            height: '100%',
                            backgroundColor: 'rgb(229,244,245)',
                        }}>
                        <Stack height="100%" direction="column" justifyContent="space-between">
                            <Stack
                                sx={{
                                    backgroundColor: 'rgb(229,244,245)',
                                    borderRadius: 1,
                                    padding: '4px 8px',
                                    width: '100%',
                                    my: 1,
                                }}>
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                    {audition.usage.map((usageItem, index) => (
                                        <Chip
                                            key={index}
                                            label={usageItem}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#000',
                                                color: theme[themeStyle].true_white,
                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                borderRadius: '6px',
                                                fontSize: 10,
                                                height: '24px',
                                                textTransform: 'capitalize',
                                            }}
                                        />
                                    ))}
                                </Stack>
                            </Stack>
                        </Stack>
                    </Card>
                </>
            )}
        </Stack>
    );
};

export { AuditionWorkDetails };
